document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded',function(){
  var h=document.querySelector('[data-dogme-header]');
  if(h){
    var m=h.querySelector('[data-menu-drawer]'),mc=h.querySelector('[data-menu-close]'),p=h.querySelector('[data-search-panel]'),o=h.querySelector('[data-search-open]'),c=h.querySelector('[data-search-close]');
    function cm(){if(m)m.removeAttribute('open')}
    function cs(){if(!p)return;p.hidden=true;o.setAttribute('aria-expanded','false')}
    function os(){cm();p.hidden=false;o.setAttribute('aria-expanded','true');var f=p.querySelector('input[type="search"]');if(f)setTimeout(function(){f.focus()},50)}
    if(mc)mc.addEventListener('click',cm);
    if(o)o.addEventListener('click',function(){p.hidden?os():cs()});
    if(c)c.addEventListener('click',cs);
    if(m)m.addEventListener('toggle',function(){if(m.open)cs()});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'){cm();cs()}});
  }

  document.querySelectorAll('[data-featured-carousel]').forEach(function(carousel){
    var track=carousel.querySelector('[data-featured-track]'),viewport=carousel.querySelector('[data-featured-viewport]'),slides=carousel.querySelectorAll('.featured-slide'),prev=carousel.querySelector('[data-featured-prev]'),next=carousel.querySelector('[data-featured-next]'),status=carousel.parentElement.querySelector('[data-featured-status]'),page=0,touchX=0,timer=null;
    function perPage(){return window.matchMedia('(max-width:749px)').matches?1:4}
    function pages(){return Math.max(1,Math.ceil(slides.length/perPage()))}
    function update(){var total=pages();page=(page+total)%total;var gap=parseFloat(getComputedStyle(track).gap)||0;var width=slides[0]?slides[0].getBoundingClientRect().width:0;track.style.transform='translate3d('+(-(width+gap)*perPage()*page)+'px,0,0)';prev.disabled=total<2;next.disabled=total<2;if(status)status.textContent=(page+1)+' / '+total}
    function stop(){if(timer){window.clearInterval(timer);timer=null}}
    function start(){stop();if(carousel.getAttribute('data-autoplay')==='true'&&pages()>1&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){var delay=parseInt(carousel.getAttribute('data-interval'),10)||5000;timer=window.setInterval(function(){page++;update()},delay)}}
    prev.addEventListener('click',function(){page--;update();start()});next.addEventListener('click',function(){page++;update();start()});
    viewport.addEventListener('touchstart',function(e){touchX=e.changedTouches[0].clientX;stop()},{passive:true});
    viewport.addEventListener('touchend',function(e){var dx=e.changedTouches[0].clientX-touchX;if(Math.abs(dx)>45){page+=dx<0?1:-1;update()}start()},{passive:true});
    carousel.addEventListener('mouseenter',stop);carousel.addEventListener('mouseleave',start);carousel.addEventListener('focusin',stop);carousel.addEventListener('focusout',start);
    window.addEventListener('resize',update);update();
    start();
  });

  document.querySelectorAll('[data-main-slider]').forEach(function(slider){
    var track=slider.querySelector('[data-main-slider-track]'),viewport=slider.querySelector('[data-main-slider-viewport]'),slides=slider.querySelectorAll('[data-main-slide]'),prev=slider.querySelector('[data-main-slider-prev]'),next=slider.querySelector('[data-main-slider-next]'),dots=slider.querySelectorAll('[data-main-slider-dot]'),status=slider.querySelector('[data-main-slider-status]'),index=0,touchX=0,timer=null;
    if(!track||slides.length<2)return;
    function update(){
      index=(index+slides.length)%slides.length;
      track.style.transform='translate3d('+(-100*index)+'%,0,0)';
      dots.forEach(function(dot,i){if(i===index)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current')});
      if(status)status.textContent=(index+1)+' / '+slides.length;
    }
    function stop(){if(timer){window.clearInterval(timer);timer=null}}
    function start(){stop();if(slider.getAttribute('data-autoplay')==='true'){var delay=parseInt(slider.getAttribute('data-interval'),10)||5000;timer=window.setInterval(function(){index++;update()},delay)}}
    if(prev)prev.addEventListener('click',function(){index--;update();start()});
    if(next)next.addEventListener('click',function(){index++;update();start()});
    dots.forEach(function(dot){dot.addEventListener('click',function(){index=parseInt(dot.getAttribute('data-main-slider-dot'),10)||0;update();start()})});
    viewport.addEventListener('touchstart',function(e){touchX=e.changedTouches[0].clientX;stop()},{passive:true});
    viewport.addEventListener('touchend',function(e){var dx=e.changedTouches[0].clientX-touchX;if(Math.abs(dx)>42){index+=dx<0?1:-1;update()}start()},{passive:true});
    slider.addEventListener('mouseenter',stop);
    slider.addEventListener('mouseleave',start);
    slider.addEventListener('focusin',stop);
    slider.addEventListener('focusout',start);
    document.addEventListener('shopify:block:select',function(e){var selected=Array.prototype.indexOf.call(slides,e.target);if(selected>-1){index=selected;update();stop()}});
    update();start();
  });

  document.querySelectorAll('[data-product-gallery]').forEach(function(gallery){
    var viewport=gallery.querySelector('[data-product-gallery-viewport]'),track=gallery.querySelector('[data-product-gallery-track]'),slides=Array.prototype.slice.call(gallery.querySelectorAll('[data-product-media-slide]')),thumbs=Array.prototype.slice.call(gallery.querySelectorAll('[data-product-gallery-thumb]')),thumbsContainer=gallery.querySelector('.product-gallery__thumbs'),prev=gallery.querySelector('[data-product-gallery-prev]'),next=gallery.querySelector('[data-product-gallery-next]'),status=gallery.querySelector('[data-product-gallery-status]'),lightbox=gallery.querySelector('[data-product-lightbox]'),lightboxImage=gallery.querySelector('[data-product-lightbox-image]'),lightboxClose=gallery.querySelector('[data-product-lightbox-close]'),index=0,touchStartX=0,touchStartY=0,suppressZoom=false;
    if(!viewport||!track||!slides.length)return;

    function pauseInactiveMedia(){
      slides.forEach(function(slide,slideIndex){
        if(slideIndex===index)return;
        slide.querySelectorAll('video').forEach(function(video){video.pause()});
        slide.querySelectorAll('model-viewer').forEach(function(model){if(model.pause)model.pause()});
      });
    }

    function showSlide(nextIndex,focusThumb){
      index=(nextIndex+slides.length)%slides.length;
      track.style.transform='translate3d('+(-100*index)+'%,0,0)';
      slides.forEach(function(slide,slideIndex){
        var active=slideIndex===index;
        slide.classList.toggle('is-active',active);
        slide.setAttribute('aria-hidden',active?'false':'true');
      });
      thumbs.forEach(function(thumb,thumbIndex){
        var active=thumbIndex===index;
        thumb.classList.toggle('is-active',active);
        thumb.setAttribute('aria-selected',active?'true':'false');
        if(active){
          if(thumbsContainer){
            var thumbLeft=thumb.offsetLeft-thumbsContainer.offsetLeft,thumbRight=thumbLeft+thumb.offsetWidth;
            if(thumbLeft<thumbsContainer.scrollLeft||thumbRight>thumbsContainer.scrollLeft+thumbsContainer.clientWidth){thumbsContainer.scrollTo({left:Math.max(0,thumbLeft-8),behavior:'smooth'})}
          }
          if(focusThumb)thumb.focus();
        }
      });
      if(status)status.textContent=(index+1)+' / '+slides.length;
      pauseInactiveMedia();
    }

    if(prev)prev.addEventListener('click',function(){showSlide(index-1,false)});
    if(next)next.addEventListener('click',function(){showSlide(index+1,false)});
    thumbs.forEach(function(thumb){
      thumb.addEventListener('click',function(){showSlide(parseInt(thumb.getAttribute('data-media-index'),10)||0,false)});
    });

    viewport.addEventListener('keydown',function(event){
      if(event.key==='ArrowLeft'){event.preventDefault();showSlide(index-1,true)}
      if(event.key==='ArrowRight'){event.preventDefault();showSlide(index+1,true)}
    });
    viewport.addEventListener('touchstart',function(event){
      touchStartX=event.changedTouches[0].clientX;
      touchStartY=event.changedTouches[0].clientY;
      suppressZoom=false;
    },{passive:true});
    viewport.addEventListener('touchend',function(event){
      var deltaX=event.changedTouches[0].clientX-touchStartX,deltaY=event.changedTouches[0].clientY-touchStartY;
      if(Math.abs(deltaX)>45&&Math.abs(deltaX)>Math.abs(deltaY)){
        suppressZoom=true;
        showSlide(index+(deltaX<0?1:-1),false);
        window.setTimeout(function(){suppressZoom=false},100);
      }
    },{passive:true});

    gallery.querySelectorAll('[data-product-zoom]').forEach(function(button){
      button.addEventListener('click',function(){
        if(suppressZoom)return;
        if(!lightbox||!lightboxImage)return;
        lightboxImage.src=button.getAttribute('data-full-image');
        lightboxImage.alt=button.getAttribute('data-image-alt')||'';
        if(typeof lightbox.showModal==='function')lightbox.showModal();else lightbox.setAttribute('open','');
      });
    });
    function closeLightbox(){if(!lightbox)return;if(typeof lightbox.close==='function')lightbox.close();else lightbox.removeAttribute('open')}
    if(lightboxClose)lightboxClose.addEventListener('click',closeLightbox);
    if(lightbox)lightbox.addEventListener('click',function(event){if(event.target===lightbox)closeLightbox()});

    var productSection=gallery.closest('.product-main');
    var variantSelect=productSection?productSection.querySelector('[data-product-variant-select]'):null;
    if(variantSelect){
      variantSelect.addEventListener('change',function(){
        var selected=variantSelect.options[variantSelect.selectedIndex],mediaId=selected?selected.getAttribute('data-featured-media-id'):null;
        if(!mediaId)return;
        var targetIndex=slides.findIndex(function(slide){return slide.getAttribute('data-media-id')===mediaId});
        if(targetIndex>-1)showSlide(targetIndex,false);
      });
    }

    showSlide(0,false);
  });

  var subject=document.getElementById('DogmeContactSubject');
  document.querySelectorAll('[data-contact-kind]').forEach(function(button){button.addEventListener('click',function(){if(subject){subject.value=button.getAttribute('data-contact-kind');subject.focus();document.getElementById('contact-form').scrollIntoView({behavior:'smooth',block:'start'})}})});
});
